(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/assets/react/param-handler.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/assets/react/param-handler.js');
"use strict";

const _React = React,
  useEffect = _React.useEffect;
const _ReactRouterDOM = ReactRouterDOM,
  useLocation = _ReactRouterDOM.useLocation;
const logger = svs.lyckoplatsen.logger;
const ParamHandler = _ref => {
  let _ref$params = _ref.params,
    params = _ref$params === void 0 ? [] : _ref$params;
  const location = useLocation();
  useEffect(() => {
    try {
      params.forEach(_ref2 => {
        var _svs$utils$paramHandl;
        let key = _ref2.key,
          action = _ref2.action;
        const value = (_svs$utils$paramHandl = svs.utils.paramHandler.get({
          key
        })) === null || _svs$utils$paramHandl === void 0 ? void 0 : _svs$utils$paramHandl.value;
        if (value) {
          action(value);
          svs.utils.paramHandler.remove({
            key
          });
        }
      });
    } catch (error) {
      logger.error('Error With ParamHandlar', error);
    }
  }, [location]);
  return null;
};
Object.assign(svs.lyckoplatsen.react, {
  ParamHandler
});

 })(window);